import { FC, useState } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { selectEsimInfo, selectIsEsimOnly } from '@telialt/utils/src/eshopSelectors';

import { RectShapedButton } from '../SpecialOffers/SpecialOffersBlock/components/RectShapedButton';
import { ESimInfoSection, ESimInfoSectionTitle } from './ESimInfoCard.styles';
import { ESimInfoModal } from './ESimInfoModal';
import { ESIM_CARD_TEST_ID } from './test-ids';

export const ESimInfoCard: FC = () => {
    const { t } = useTranslations();
    const { cart } = useCartQuery();
    const [isModalOpen, setModalOpen] = useState(false);
    const esimInfo = selectEsimInfo(cart);

    if (!selectIsEsimOnly(cart) || !esimInfo) {
        return null;
    }

    return (
        <ESimInfoSection data-test={ESIM_CARD_TEST_ID.SECTION}>
            <ESimInfoSectionTitle tag="h3" variant="title-100">
                {t['eshop.product_page.esim_info.title']}
            </ESimInfoSectionTitle>
            <RectShapedButton
                icon={esimInfo.icon}
                iconVariant="info"
                onClick={() => setModalOpen(true)}
                aria-haspopup="dialog"
                data-test={ESIM_CARD_TEST_ID.TRIGGER}
            >
                {esimInfo.title}
            </RectShapedButton>
            <ESimInfoModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                title={esimInfo.title}
                description={esimInfo.description}
                image={esimInfo.image}
                imagePosition={esimInfo.imagePosition}
            />
        </ESimInfoSection>
    );
};
